module.exports = __webpack_public_path__ + "static/media/Next-alt.52aef54b.svg";